module.exports = __webpack_public_path__ + "img/favicon.1ba2ae71.ico";